var $ = require('../jquery/jquery');
var serialize = require('serialize-javascript');

var TokenRepository = function (serviceUrl) {
    return {
        create: function (requestData, authToken) {
            var endpoint = serviceUrl + '/tokens';
            var headers = {};

            if (authToken) {
                endpoint += '/sps';
                headers.Authorization = authToken;
            }

            return $.ajax({
                url: endpoint,
                headers: headers,
                type: "POST",
                data: serialize(requestData, { isJSON: true }),
                contentType: "application/json"
            });
        }
    }
};

module.exports = TokenRepository;
